import {Injectable} from '@angular/core';
import {SortModel, SortOrder} from '../sort-order-dialog/sort-order-dialog.component';
import {VeritiyPricesTableRowModel} from '../../../prices-view/models/verity-prices-table-row-model';
import {TableChartState} from '../../../prices-view/components/verity-prices-table/table-chart-state';

@Injectable({
  providedIn: 'root'
})
export class TableViewService {

  tableChartState: TableChartState = TableChartState.TABLE;

  constructor() {
  }

  public setProperWidth(tableData: Array<any>, tableColumns: Array<VeritiyPricesTableRowModel>) {
    tableColumns.filter(column => column.dynamicWidth)
      .forEach(column => {
        let maxLength = 0;
        let maxRowText = '';
        tableData.forEach(row => {
          if (row[column.key].length > maxLength) {
            maxLength = row[column.key].length;
            maxRowText = column.name + ' : ' + row[column.key];
          }
        });
        column.width = maxLength * 7;
      });
  }

  public customSorting() {
    return (item, property) => {
      if (property === 'Manufacturer') {
        const newManufacturer = item['Manufacturer'].toLowerCase().replace(/[^a-z0-9]/g, '');

        return newManufacturer;
      }

      if (property === 'Strength') {
        const valA = item['Strength'];

        return Number(valA.substring(0, valA.indexOf(' ')));
      }

      if (property === 'Mandatory_discount') {
        return Number(item['Mandatory_discount']);
      }

      if (!item[property] || item[property] === '') {
        return '';
      }

      if (!isNaN(Number(item[property]))) {
        return Number(item[property]);
      }

      return item[property];
    };
  }

  public performGroupedSort(columns: Array<SortModel>, dataToSort: Array<any>) {
    dataToSort.sort((a, b) => {
      for (const col of columns) {
        if (isNaN(a[col.key]) && isNaN(b[col.key])) {
          let valA = a[col.key];
          let valB = b[col.key];
          let result = 0;

          if (col.key === 'Strength') {
            valA = Number(valA.substring(0, valA.indexOf(' ')));
            valB = Number(valB.substring(0, valB.indexOf(' ')));
          }

          if (valA < valB) {
            result = -1;
          } else if (valA > valB) {
            result = 1;
          } else {
            continue;
          }

          if (col.sortOrder === SortOrder.DESCENDING) {
            return result * -1;
          }
          return result;

        } else {
          if (col.sortOrder === SortOrder.DESCENDING) {
            return (Number(a[col.key]) - Number(b[col.key])) * -1;
          }

          return Number(a[col.key]) - Number(b[col.key]);
        }
      }
      return 0;
    });

    return dataToSort;

  }

}

export enum CurrencyType {
  NONE = -1,
  CHF = 0,
  EUR = 1,
  GBP = 2,
  USD = 3
}
